export const AddRoundFilled = (props : any) => {
    return (
        <svg width={props.width || "16"} height={props.height || "16"} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 8a6 6 0 1 1 12 0A6 6 0 1 1 2 8zm6 2.625c.312 0 .563-.25.563-.563v-1.5h1.5a.561.561 0 1 0 0-1.125h-1.5v-1.5A.561.561 0 0 0 8 5.375a.561.561 0 0 0-.563.563v1.5h-1.5A.561.561 0 0 0 5.375 8c0 .312.25.563.563.563h1.5v1.5c0 .311.25.562.562.562z" fill={props.color || "#33C"} />
        </svg>
    );
}
